export default "__VITE_ASSET__DF5k_ydc__"